export class PoNode {
  product;
  abb;
  abbDescription;
  administrationCode;
  arrangementNumber;
  arrangementUrl;
  bankCode;
  count;
  commercialProductTypeCode;
  detailsURI;
  iban;
  number;
  packageName;
  parentCustomerId;
  relation;
  relationWithRole;
  restrictedData;
  restrictedDataViewException;
  relationMarketSegmentCode;
  screenLinkIdFlag;
  hasProductServices;
  hasBoCockpit;
  specifics;
  specificsLabels;
  statusCode;
  statusCodeLabel;
  totalAmount;
  totalAmountCurrencyCode;
  totalAmountSuffix;
}
